import { InternalTemplateDetails } from "features/internal/template/InternalTemplateDetails";
import {
  useInternalEventImportExportRetrieveSuspense,
  useInternalEventTemplateVersionRetrieve,
} from "gen/endpoints/internal/internal";
import { useTranslation } from "react-i18next";
import PageBody from "shared/components/layout/PageBody";
import PageContent from "shared/components/layout/PageContent";
import { PageHeader } from "shared/components/layout/PageHeader";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";

export const InternalTemplateExportPage: React.FC = () => {
  const { t } = useTranslation(["common", "internal"]);
  const { templateVersionId, templateImportExportId } =
    useRequiredStringParams();
  const { data: importExportData } =
    useInternalEventImportExportRetrieveSuspense(templateImportExportId);

  const { data: templateData } = useInternalEventTemplateVersionRetrieve(
    importExportData.event_template_version_id,
    {
      query: {
        enabled: !!importExportData,
      },
    },
  );

  return (
    <PageContent isFullHeight={true}>
      {templateData && (
        <PageHeader
          title={templateData.name}
          helperText={templateData.description}
          backButton={{
            title: t("common:back"),
          }}
        />
      )}
      <PageBody>
        <InternalTemplateDetails
          templateVersionId={templateVersionId}
          templateImportExportId={templateImportExportId}
        />
      </PageBody>
    </PageContent>
  );
};
